import Vue from 'vue'
import { fetchUsers, createUser, deleteUser, updateUser } from "@/api";
import router from '@/router';

/**
 * @var {{ messages: { responses: { user_created } }, created_at, users, data: { current_page, per_page } }} lang
 *
 * @description json definition for nested data
 */
export default {
    namespaced: true,
    state: {
        paginated: {
            current: 1,
            data: [],
            total: 1,
            pageSize: 10,
            showQuickJumper: true
        },
        isLoading: false,
        visible_create: false
    },
    mutations: {
        SET_PAGINATED_USERS: (state, paginated) => state.paginated = paginated,
        SET_LOADING: state => state.isLoading = !state.isLoading,
        TOGGLE_VISIBLE_MODAL: state => state.visible_create = !state.visible_create,
        FORCE_CLOSE_MODAL: state => state.visible_create = false
    },
    actions: {
        /**
         *
         * @param {function} commit
         * @param {object} state
         * @param {int} page
         * @param {boolean} force
         */
        fetchUsers({ commit, state }, { page = 1, force = false, search = '' }) {
            if (force || !state.paginated.data.length) {
                commit('SET_LOADING');

                fetchUsers(page, search)
                    .then(res => {

                    commit('SET_PAGINATED_USERS', {
                        ...res.data,
                        current: res.data.current_page,
                        pageSize: res.data.per_page,
                        data: res.data.data
                    });

                    commit('FORCE_CLOSE_MODAL');

                    // if (router.history.current.query.page && router.history.current.query.page !== page) {
                        router.replace({ query: { page } });
                    // }

                }).finally(() => commit('SET_LOADING'))
            }
        },

        /**
         *
         * @param {function} commit
         * @param {function} dispatch
         * @param {object} lang
         * @param {{ email: string, name: string, type: int }} user
         */
        register({ commit, dispatch, rootGetters: { lang } }, user) {
            if (user.username && user.email == '') {
                delete user.email
            }
            createUser(user).then(() => {
                dispatch('fetchUsers', { force: true });
                commit('TOGGLE_VISIBLE_MODAL');
                Vue.prototype.$message.success(lang.messages.responses.user_created).finally(() => false)
            })
        },

        update({ dispatch }, user) {
            updateUser(user).then(() => dispatch('fetchUsers', { force: true }))
        },

        remove({ dispatch }, id) {
            deleteUser(id).then(() => dispatch('fetchUsers', { force: true }))
        },
    },
    getters: {
        fields: (state, getters, rootState, rootGetters) => {
            const lang = rootGetters.lang.users.main_table;
            return [
                { title: '', dataIndex: 'id', key: 'id', sorter: false, scopedSlots: { customRender: 'id' } },
                { title: lang.name, dataIndex: 'name', key: 'name', sorter: false, scopedSlots: { customRender: 'name' } },
                { title: 'ID de cliente', dataIndex: 'username', key: 'username', sorter: false, scopedSlots: { customRender: 'username' } },
                { title: 'Correo electrónico', dataIndex: 'email', key: 'email', sorter: false, scopedSlots: { customRender: 'email' } },
                // { title: lang.email, dataIndex: 'email', key: 'email', sorter: false, scopedSlots: { customRender: 'email' } },
                { title: lang.role, dataIndex: 'type', key: 'type', sorter: false, scopedSlots: { customRender: 'type' } },
                { title: lang.created_at, dataIndex: 'created_at', key: 'created_at', sorter: false, scopedSlots: { customRender: 'created_at' } },
                { title: '', dataIndex: 'id', key: 'delete', sorter: false, scopedSlots: { customRender: 'delete' } },
            ]
        }
    }
}